// src/components/CoreAssure/Kpi/KpiTile.js
//
// Single KPI tile — value + unit + color + threshold + optional detail.

import React from "react";
import { Card, CardContent, Stack, Typography, Box, Tooltip } from "@mui/material";
import { KPI_COLOR_PALETTE, formatKpiValue } from "../../../utils/coreassure/kpiApi";

export default function KpiTile({ kpi }) {
  if (!kpi) return null;
  const palette = KPI_COLOR_PALETTE[kpi.color] || KPI_COLOR_PALETTE.GREY;
  const display = formatKpiValue(kpi.value, kpi.unit);

  const tooltipText = kpi.threshold
    ? `Threshold: ${kpi.threshold}${kpi.detail ? ` — ${kpi.detail}` : ""}`
    : (kpi.detail || "");

  return (
    <Tooltip title={tooltipText} placement="top">
      <Card sx={{
        bgcolor: palette.bg,
        border: `2px solid ${palette.border}`,
        height: "100%",
      }}>
        <CardContent>
          <Stack spacing={0.5}>
            <Typography variant="caption" sx={{ color: palette.fg, letterSpacing: 0.3, fontWeight: 700 }}>
              {kpi.id || ""}
            </Typography>
            <Typography variant="caption" sx={{ color: palette.fg, fontWeight: 600 }}>
              {kpi.name}
            </Typography>
            <Box sx={{ pt: 1 }}>
              <Typography variant="h4" sx={{ fontWeight: 800, color: palette.fg, lineHeight: 1 }}>
                {display}
              </Typography>
              {kpi.unit && kpi.unit !== "%" && kpi.value != null && (
                <Typography variant="caption" sx={{ color: palette.fg }}>
                  {kpi.unit}
                </Typography>
              )}
            </Box>
            {kpi.detail && (
              <Typography variant="caption" sx={{ color: palette.fg, fontStyle: "italic", pt: 0.5 }}>
                {kpi.detail}
              </Typography>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Tooltip>
  );
}
